import SimpleTooltip from "@rio-cloud/rio-uikit/SimpleTooltip";

export const splitDriverNames = (driver: string) => {
  const driverParts = driver.split(",");
  const lastDriverIndex = driverParts.length - 1;

  return driverParts
    .map((name, index) => {
      const withoutLeading = index === 0 ? name : name.trimStart();
      return index === lastDriverIndex ? withoutLeading : withoutLeading.trimEnd();
    })
    .filter(Boolean);
};

export const renderDriverContent = (driver: string | null) => {
  if (!driver) {
    return "-";
  }

  const names = splitDriverNames(driver);
  const [first, ...rest] = names;
  const restCount = rest.length;
  const full = names.join(", ");

  const content = (
    <div
      style={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      <span>{first}</span>
      {restCount ? <span className="margin-left-5 text-color-light">+{restCount}</span> : null}
    </div>
  );

  if (restCount > 0) {
    return (
      <SimpleTooltip content={full} placement="top">
        {content}
      </SimpleTooltip>
    );
  }

  return content;
};
